import React from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { SITE, MARQUEE_ITEMS, SIGNATURES, CHAPTERS } from "../content";
import { BowlArt, GangArt } from "../components/Art";
import { LineReveal, Reveal, Marquee } from "../components/Motion";

function Hero() {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const yArt = useTransform(scrollY, [0, 700], [0, reduce ? 0 : 90]);

  return (
    <section className="hero" data-testid="home-hero">
      <span className="hero__vertical">Gang Kelinci — Pasar Baru — Jakarta Pusat</span>
      <motion.div className="hero__art" style={{ y: yArt }} aria-hidden="true">
        <BowlArt />
      </motion.div>
      <p className="hero__eyebrow">Kedai Bakmi Tionghoa · Est. {SITE.established}</p>
      <h1 className="hero__title">
        <LineReveal delay={0.1}>Bakmi</LineReveal>
        <LineReveal delay={0.26}>
          <span className="accent">Aboen</span>
        </LineReveal>
      </h1>
      <div className="hero__grid">
        <Reveal delay={0.55}>
          <p className="hero__lede">
            Semangkuk bakmi kecap yang setia pada resepnya sejak {SITE.established} — di sebuah gang
            kecil di jantung Pasar Baru, Jakarta.
          </p>
          <div className="hero__ctas">
            <Link to="/menu/" className="btn btn--seal" data-testid="cta-lihat-menu">
              Lihat Menu <span className="btn__arrow">→</span>
            </Link>
            <Link to="/lokasi/" className="btn" data-testid="cta-kunjungi-kedai">
              Kunjungi Kedai
            </Link>
          </div>
        </Reveal>
      </div>
      <div className="hero__strip" data-testid="hero-info-strip">
        <span>Est. {SITE.established}</span>
        <span>Non-Halal</span>
        <span>{SITE.hoursDisplay}</span>
        <span>{SITE.phoneDisplay}</span>
      </div>
    </section>
  );
}

function Signatures() {
  return (
    <section className="section" data-testid="home-signatures">
      <Reveal className="section__head">
        <p className="section__eyebrow">Bab Pembuka — Andalan Kedai</p>
        <h2 className="section__title">Yang membuat orang kembali</h2>
      </Reveal>
      <div className="sig-list">
        {SIGNATURES.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.06}>
            <Link to="/menu/" className="sig-row" data-testid={`sig-row-${s.no}`}>
              <span className="sig-row__no">{s.no}</span>
              <span className="sig-row__name">{s.name}</span>
              <span className="sig-row__desc">{s.desc}</span>
            </Link>
          </Reveal>
        ))}
      </div>
      <Link to="/menu/" className="btn section__more" data-testid="cta-menu-lengkap">
        Lihat Menu Lengkap <span className="btn__arrow">→</span>
      </Link>
    </section>
  );
}

function Chapters() {
  return (
    <section className="section" data-testid="home-chapters">
      <Reveal className="section__head">
        <p className="section__eyebrow">Tiga Bab Tentang Kedai Ini</p>
        <h2 className="section__title">Cerita dari gang kecil</h2>
      </Reveal>
      <div className="chapters">
        {CHAPTERS.map((c) => (
          <Reveal key={c.no} className="chapter">
            <div>
              <p className="chapter__no">{c.no}</p>
              <h3 className="chapter__title">{c.title}</h3>
            </div>
            <p className="chapter__body">{c.body}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function LocationBand() {
  return (
    <section className="section band" data-testid="home-location-band">
      <Reveal>
        <p className="section__eyebrow">Kunjungi Kami</p>
        <h2 className="band__address">
          {SITE.address.street}, {SITE.address.area}, {SITE.address.city}
        </h2>
        <div className="band__meta">
          <span>{SITE.hoursDisplay}</span>
          <span>{SITE.phoneDisplay}</span>
          <span>Sejak {SITE.established}</span>
        </div>
        <div className="band__ctas">
          <a
            href={SITE.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--seal"
            data-testid="cta-petunjuk-arah"
          >
            Petunjuk Arah <span className="btn__arrow">↗</span>
          </a>
          <Link to="/kontak/" className="btn btn--paper" data-testid="cta-hubungi-kami">
            Hubungi Kami
          </Link>
        </div>
        <GangArt className="band__art" />
      </Reveal>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee items={MARQUEE_ITEMS} />
      <Signatures />
      <Chapters />
      <LocationBand />
    </>
  );
}
